import { EOrgType, IError } from '@unfoldrtech/portal-mic'
import type { UseQueryResult } from '@tanstack/react-query'
import type { AxiosError, AxiosResponse } from 'axios'
import type { IReportingCreativesTableResponse } from '@unfoldrtech/portal-mic/dist/src/models/core'

import useGetAdvertiserReportingCreativesChartV3 from '../../../../hooks/use-get-advertiser-reporting-creatives-chart-v3'
import useGetAdvertiserReportingCreativesTableV3 from '../../../../hooks/use-get-advertiser-reporting-creatives-table-v3'
import useGetRetailerReportingCreativesChartV3 from '../../../../hooks/use-get-retailer-reporting-creatives-chart-v3'
import useGetRetailerReportingCreativesTableV3 from '../../../../hooks/use-get-retailer-reporting-creatives-table-v3'

/** Single signature avoids TS inferring `advertiserHook | retailerHook`, which forces an impossible parameter intersection at call sites. */
export type TCreativesTableHookParams = Parameters<
  typeof useGetAdvertiserReportingCreativesTableV3
>[0]

type TCreativesTableHook = (
  params: TCreativesTableHookParams
) => UseQueryResult<
  AxiosResponse<IReportingCreativesTableResponse>,
  AxiosError<IError>
>

export const getTableAndChartCreativesFn = ({
  orgType = EOrgType.Advertiser,
}: {
  orgType?: EOrgType
}) => {
  const tableFn: TCreativesTableHook = (
    orgType === EOrgType.Advertiser
      ? useGetAdvertiserReportingCreativesTableV3
      : useGetRetailerReportingCreativesTableV3
  ) as TCreativesTableHook

  const chartFn =
    orgType === EOrgType.Advertiser
      ? useGetAdvertiserReportingCreativesChartV3
      : useGetRetailerReportingCreativesChartV3

  return { tableFn, chartFn }
}
